import cryptoRandomString from "crypto-random-string";
import Joi from "joi-browser";
import moment from "moment";
import { toast } from "react-toastify";

import {
  sendEmail,
  writeErrorLog,
  writeProcessLog,
} from "../components/services/soar";
import { msalInstance } from "../index";
import { ArrayCheck } from "./helperScripts";
import { zetoPost } from "../components/services/zeto";

const org =
  process.env.REACT_APP_ENVIRONMENT === "Production" ? "ReactLive" : "ReactDev";
const apiUrl = "https://safyzetoapi.azurewebsites.net/Formsy/v2";
const apiName = "Zeto API";
const applicationId =
  process.env.REACT_APP_ENVIRONMENT === "Production"
    ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
    : "58990f83-8566-4ba8-b4b5-584a64e4cba1";

export function getFormSetup() {
  const body = {
    application: applicationId,
    command: "query",
    keyword: "setup",
  };
  return zetoPost(`${apiUrl}/Version`, body);
}

export async function getFormConfig(versionId) {
  const body = {
    application: applicationId,
    command: "query",
    keyword: "byid",
    ids: [versionId],
  };
  const response = await zetoPost(`${apiUrl}/Version`, body);
  return response.data[0];
}

function getSubmission(submissionId) {
  const body = {
    application: applicationId,
    command: "query",
    keyword: "byid",
    ids: [submissionId],
  };
  return zetoPost(`${apiUrl}/Submission`, body);
}

export async function saveRelatedObject(submissionId, relatedJSON) {
  const obj = {
    submissionId: submissionId,
    related: ArrayCheck(relatedJSON),
  };
  return zetoPost(`${apiUrl}/Submission/RelatedObject`, obj);
}

export async function loadSubmission(id, signal) {
  const response = await getSubmission(id, signal);
  return response?.data[0];
}

export async function handleChange(
  input,
  setData,
  setTouched,
  setTimeoutId,
  table,
  index = -1
) {
  setData((d) => {
    const obj = { ...d };
    if (table && index !== -1) {
      obj.Results[table][index][input.name] =
        input.type === "checkbox" ? input.checked : input.value;
    } else {
      obj.Results[input.name] =
        input.type === "checkbox" ? input.checked : input.value;
    }

    setTouched((touched) => {
      const touchedObj = { ...touched, [input.name]: true };
      const touchedFields = Object.keys(touchedObj).filter(
        (field) => touchedObj[field]
      );

      setTimeoutId((timeoutId) => {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }

        let newTimeoutId;

        if (touchedFields.length >= 5) {
          saveSubmission(obj, "Update");
          touchedFields.forEach((field) => (touchedObj[field] = false));
        } else {
          newTimeoutId = setTimeout(() => {
            touchedFields.forEach((field) => (touchedObj[field] = false));
            saveSubmission(obj, "Update");
          }, 20000);
        }

        return newTimeoutId;
      });
      return touchedObj;
    });
    return obj;
  });
}

export async function saveSubmission(submissionData, command) {
  const body = {
    application: applicationId,
    command: command.toLowerCase(),
    submissionId: submissionData.SubmissionId,
    containerId: submissionData.ContainerId,
    versionId: submissionData.VersionId,
    primaryObjectId: submissionData.PrimaryObjectId,
    primaryObjectName: submissionData.PrimaryObjectName,
    primaryObjectType: submissionData.PrimaryObjectType,
    secondaryObjectId: submissionData.SecondaryObjectId,
    secondaryObjectName: submissionData.SecondaryObjectName,
    secondaryObjectType: submissionData.SecondaryObjectType,
    tertiaryObjectId: submissionData.TertiaryObjectId,
    tertiaryObjectName: submissionData.TertiaryObjectName,
    tertiaryObjectType: submissionData.TertiaryObjectType,
    results: submissionData.Results,
    compliancy: submissionData.Compliancy,
  };

  return zetoPost(`${apiUrl}/Submission`, body);
}
// TODO: JP wants to think through all of the awaits and refactor for performance if possible
export async function shareWith(submissionIds, sharedWith) {
  submissionIds.forEach(async (submissionId) => {
    //const shared = [];

    //get subission data for submissionId
    const formData = await getSubmission(submissionId);

    await sharedWith.forEach(async (s, index) => {
      //filter out shared records for s and see if already shared with user
      if (
        formData.data[0].Related === undefined ||
        formData.data[0].Related === null ||
        formData.data[0].Related?.filter(
          (f) =>
            f.ObjectType === "Shared" &&
            f.ObjectJSON.azureId.toUpperCase() === s.azureId.toUpperCase() &&
            f.Active === true
        ).length === 0
      ) {
        const safyUser = JSON.parse(localStorage.getItem("safyInfo")).user;

        const obj = {
          Action: "Insert",
          ObjectType: "Shared",
          ObjectJSON: {
            name: s.name,
            azureId: s.azureId,
            domain: s.domain,
            sharedById: safyUser.azureId.toUpperCase(),
            sharedByName: safyUser.displayName,
            sharedByDomain: safyUser.email,
            date: new Date().toLocaleDateString(),
          },
        };
        //shared.push(obj);
        //if (index === sharedWith.length - 1) {
        await saveRelatedObject(submissionId, [obj]);

        if (formData.data[0].FinalSigned === true) {
          const link = `${
            process.env.REACT_APP_ENVIRONMENT === "Production"
              ? "https://safyportal.safy.org/share"
              : "https://safyportaltest.safy.org/share"
          }/supervision/${
            formData.data[0].ContainerId ===
            "A51B13BE-6B02-EF11-8076-DC98408D5418"
              ? "individual"
              : "group"
          }/${submissionId.toString()}`;
          sendEmail(
            `${s.domain}`,
            s.sharedByDomain,
            "A Supervision Log has been shared with you",
            `${s.sharedByName} has shared a supervision log with you at  <a href="${link}">${link}</a>`
          ).then((response) => {
            console.log("Email Response", response);
            if (JSON.parse(response).SystemResponse[0].Code === "Success") {
              toast.success(`Email Sent To ${s.domain}`);
            } else {
              toast.error(
                `Error in sending email: ${
                  JSON.parse(response).SystemResponse[0].Message
                }`
              );
            }
          });
        }
        // } else {
        // }
        console.log("Skipping, Already Shared With User");
      }
    });
  });
}

export function deactivateShared(submissionId) {
  return getSubmission(submissionId).then((response) => {
    const safyUser = JSON.parse(localStorage.getItem("safyInfo")).user;

    const submission = response.data[0];
    const shared = submission.Related.filter(
      (r) =>
        r.ObjectType === "Shared" &&
        r.ObjectJSON.azureId.toUpperCase() === safyUser.azureId.toUpperCase() &&
        r.Active === true
    );

    let deactiveRecords = [];
    shared.forEach((i) => {
      const obj = {
        Action: "Deactivate",
        RelatedId: i.RelatedId,
      };
      deactiveRecords.push(obj);
    });

    toast.success("Removed");
    return saveRelatedObject(submissionId, deactiveRecords);
  });
}

export function deactivateForm(submissionId) {
  return saveSubmission(
    {
      SubmissionId: submissionId,
    },
    "Deactivate"
  );
}

export function signForm(submissionId, signature) {
  return saveRelatedObject(submissionId, ArrayCheck(signature));
}

export function finalSignForm(submissionId) {
  return saveSubmission(
    {
      SubmissionId: submissionId,
    },
    "FinalSign"
  ).then((response) => {
    if (response.code !== "success") {
      toast.error(`Error: ${response.message}`);
    }
    return response;
  });
}

export function lockForm(submissionId) {
  const log = {
    SubmissionId: submissionId,
  };

  return saveSubmission(log, "FormLock").then((response) => {
    if (response.code !== "success") {
      toast.error(`Error: ${response.message}`);
    }
  });
}

export async function shareLockedForm(data, signersRole) {
  const link = `${
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "https://safyportal.safy.org/share"
      : "https://safyportaltest.safy.org/share"
  }/supervision/${
    data.ContainerId === "A51B13BE-6B02-EF11-8076-DC98408D5418"
      ? "individual"
      : "group"
  }/${data.SubmissionId.toString()}`;
  const initiatingUser =
    signersRole === "Supervisee"
      ? `${data.PrimaryObjectUser}@safy.org`
      : `${data.SecondaryObjectUser}@safy.org`;
  const initiatingName =
    signersRole === "Supervisee"
      ? `${data.PrimaryObjectName}@safy.org`
      : `${data.SecondaryObjectName}@safy.org`;
  const sharedUser =
    signersRole === "Supervisee"
      ? `${data.SecondaryObjectUser}@safy.org`
      : `${data.PrimaryObjectUser}@safy.org`;
  sendEmail(
    sharedUser,
    initiatingUser,
    "Supervision Log",
    `${initiatingName} has completed a supervision log for you at <a href="${link}">${link}</a>`
  ).then((response) => {
    console.log("Email Response", response);
    if (JSON.parse(response).SystemResponse[0].Code === "Success") {
      toast.success(`Email Sent To ${sharedUser}`);
    } else {
      toast.error(
        `Error in sending email: ${
          JSON.parse(response).SystemResponse[0].Message
        }`
      );
    }
  });

  const shared = data?.Related?.filter(
    (r) => r.ObjectType === "Shared" && r.Active === true
  );

  if (shared?.length > 0) {
    shared.forEach((s) => {
      const sharedUser = s.ObjectJSON.domain;
      const sharedBy = s.ObjectJSON.sharedByName;
      sendEmail(
        sharedUser,
        "safyautoemail@Safy365.onmicrosoft.com",
        "A Supervision Log has been shared with you",
        `${sharedBy} has shared a supervision log with you at <a href="${link}">${link}</a>`
      ).then((response) => {
        console.log("Email Response", response);
        if (JSON.parse(response).SystemResponse[0].Code === "Success") {
          toast.success(`Email Sent To ${sharedUser}`);
        } else {
          toast.error(
            `Error in sending email: ${
              JSON.parse(response).SystemResponse[0].Message
            }`
          );
        }
      });
    });
  }
}

export async function saveForm(data, command) {
  return saveSubmission(data, command);
}

export async function cloneForm(data, navigate, location, formsyConfig) {
  console.group("Formsy Clone");
  let path = location.pathname.split("/")[1];
  let formid = location.pathname.split("/")[2];
  const clientid = location.pathname.split("/")[3];
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo")).user;

  const formData = { ...data };
  console.log("Form Data", formData);

  const helperConfig =
    formsyConfig.HelperConfiguration && formsyConfig.HelperConfiguration[0]
      ? JSON.parse(formsyConfig.HelperConfiguration[0])
      : {};
  console.log("Helper Config", helperConfig);

  const excludeCloning = helperConfig.excludeCloning || [];

  for (const fieldName of excludeCloning) {
    const field = formData[fieldName];
    const existingValue = field !== undefined ? field.value : undefined;

    if (existingValue === undefined) {
      continue;
    }

    if (
      existingValue === "[]" ||
      (existingValue.startsWith("[{") && existingValue.endsWith("}]"))
    ) {
      if (
        !formsyConfig.FormConfiguration[0].config[0][fieldName].emptyOnClone
      ) {
        // eslint-disable-next-line no-useless-escape
        formData[fieldName].value = `[{"_id":"${cryptoRandomString(
          10
        )}","IsEditable":true}]`;
      } else {
        formData[fieldName].value = "[]";
      }
    } else formData[fieldName].value = "";
  }

  // for when you want to exclude specific columns from a "table" field
  // example: excludeCloningTables: [{"tableName": "TableA", "fieldsExcluded": ["FieldA", "FieldB"]}]
  const excludeCloningTables = helperConfig.excludeCloningTables || [];

  console.group("Exclude Cloning");
  excludeCloningTables.forEach((tableInfo) => {
    console.log("Table Info", tableInfo);

    const tableData =
      formData[tableInfo.tableName] !== undefined &&
      formData[tableInfo.tableName].value !== undefined &&
      formData[tableInfo.tableName].value.startsWith("[{") &&
      formData[tableInfo.tableName].value.endsWith("}]")
        ? JSON.parse(formData[tableInfo.tableName].value)
        : [];

    if (tableData !== undefined) {
      console.log("Table Data", tableData);
      tableData.forEach((tableRow) => {
        tableInfo.fieldsExcluded.forEach((fieldName) => {
          tableRow[fieldName] = "";
        });
      });
      console.log("Excluded Table Data", tableData);
      formData[tableInfo.tableName].value = JSON.stringify(tableData);
    }
  });
  console.groupEnd();

  console.log("Pre Clone Data:", formData);
  formData.Comments = "";
  formData.Signatures = "";
  formData.FinalSigned = "0";
  formData.FinalSignedDate = "";
  formData.Active = "1";
  formData.CreatedById = safyInfo.safyInfo.AzureAdId;
  formData.CreatedByName = safyInfo.displayName;
  formData.ModifiedById = safyInfo.safyInfo.AzureAdId;
  formData.ModifiedByName = safyInfo.displayName;

  if (helperConfig.buttonBarConfig.cloneVersion) {
    const setupConfig =
      formsyConfig.SetupConfiguration && formsyConfig.SetupConfiguration[0]
        ? JSON.parse(formsyConfig.SetupConfiguration[0])
        : {};
    path = `${setupConfig.formPath}v${helperConfig.buttonBarConfig.cloneVersion.versionNumber}`;
    formData.FormVersionId = helperConfig.buttonBarConfig.cloneVersion.id;
    formid = helperConfig.buttonBarConfig.cloneVersion.id;
  }

  console.log("Form Clone Object", formData);

  var accessToken = await msalInstance.acquireTokenSilent({
    scopes: ["https://eurekaapi.azurewebsites.net/access_as_user"],
  });

  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(formData),
  };
  const toastId = toast.loading("Cloning...", {
    type: toast.TYPE.INFO,
  });
  fetch(
    `https://eurekaapi.azurewebsites.net/Formsy/Upsert/Submission/${org}/Insert`,
    requestOptions
  )
    .then((response) => response.json())
    .then((data) => {
      const dataJson = JSON.parse(data);

      if (dataJson.SystemResponse?.[0]?.Code === "SUCCESS") {
        toast.update(toastId, {
          render: "Form Cloned",
          type: toast.TYPE.SUCCESS,
          autoClose: 5000,
          isLoading: false,
          closeOnClick: true,
        });

        const trimmedResults = { ...formData };
        delete trimmedResults.FormResults;
        delete trimmedResults.Signatures;
        delete trimmedResults.Comments;

        const logData = {
          Type: `Formsy Clone`,
          Location: process.env.REACT_APP_ENVIRONMENT,
          Description: location.pathname,
          Data: JSON.stringify(trimmedResults),
          ObjectReferenceType: "Form",
          ObjectReferenceId: JSON.parse(data).SystemResponse[0].Id,
        };

        writeProcessLog(logData);
        navigate(
          `/${path}/${formid}/${clientid}/${
            JSON.parse(data).SystemResponse[0].Id
          }`,
          { replace: true, state: location.state }
        );
      } else {
        toast.update(toastId, {
          render: "Error in cloning form.",
          type: toast.TYPE.ERROR,
          autoClose: 5000,
          isLoading: false,
          closeOnClick: true,
        });
        console.log(
          "FormsyCloneError",
          dataJson.SystemResponse[0].Message,
          formData
        );

        const logData = {
          Who: `${safyInfo.user.domainName}|${safyInfo.user.displayName}`,
          FullError: JSON.stringify(dataJson),
          API: apiName,
          APIBody: JSON.stringify(formData),
          URL: `Formsy/Upsert/Submission/${org}/Insert`,
          Org: process.env.REACT_APP_ENVIRONMENT,
          ResponseCode: dataJson.SystemResponse[0].Code,
          ResponseMessage: dataJson.SystemResponse[0].Message,
          ExceptionType: `Formsy Clone Error`,
          Application: "React Portal/Formsy",
        };

        writeErrorLog(logData);
      }
    });
  console.groupEnd();
}

export function saveSignature(signatureData, formsyConfig, formsyDetails) {
  const returnObj = { FormsyDetails: { ...formsyDetails } };
  console.log("Signature Data:", signatureData);
  let sigArray = [];

  if (Array.isArray(signatureData)) {
    sigArray = signatureData;
  } else {
    sigArray.push(signatureData);
  }

  returnObj.Signatures = sigArray;

  if (returnObj.FormsyDetails.FinalSigned === "1") {
    return returnObj;
  }

  if (checkFinalSigned(sigArray, formsyConfig)) {
    console.log("Final Signed");
    returnObj.FormsyDetails.FinalSigned = "1";

    if (
      formsyDetails.FinalSignedDate === "" ||
      formsyDetails.FinalSignedDate === "1900-01-01T00:00:00"
    ) {
      returnObj.FormsyDetails.FinalSignedDate = new Date();
    }
  }

  return returnObj;
}

function checkFinalSigned(sigArray, formsyConfig) {
  const requiredSignatureTypes = JSON.parse(
    formsyConfig.HelperConfiguration[0]
  ).finalSignType.split(",");

  const capturedSignatureTypes = sigArray.map((sig) => sig.signatureType);
  console.log("requiredSignatureTypes: ", requiredSignatureTypes);
  console.log("capturedSignatureTypes: ", capturedSignatureTypes);

  const missingSigTypes = requiredSignatureTypes.filter(
    (type) => !capturedSignatureTypes.includes(type)
  );

  return missingSigTypes.length === 0;
}

export function validateForm(data, schema) {
  let dataObj = {};

  for (const property in data) {
    if (data[property] && data[property].value)
      dataObj[property] = data[property].value;
  }
  const options = { abortEarly: false };
  const { error } = Joi.validate(dataObj, schema, options);
  if (!error) return {};

  let validationErrors = {};
  for (let item of error.details)
    validationErrors[item.path[0]] = validationErrors[item.path[0]] ? (
      (validationErrors[item.path[0]] = (
        <>
          {validationErrors[item.path[0]]}
          <br />
          <>{item.message}</>
        </>
      ))
    ) : (
      <>{item.message}</>
    );

  if (Object.keys(validationErrors).length > 0) {
    console.group("validateForm validationErrors");
    console.log(data);
    console.log(dataObj);
    console.log(validationErrors);
    console.groupEnd();
  }
  return validationErrors;
}

export function validateFormProperty(input, schema) {
  const obj = {
    [input.name]: input.type === "checkbox" ? input.checked : input.value,
  };
  const objSchema = { [input.name]: schema[input.name] };
  const { error } = Joi.validate(obj, objSchema);
  return error ? error.details[0].message : null;
}

export function handleFormChange(input, data, schema, errors) {
  const errs = { ...errors };
  const errorMessage = validateFormProperty(input, schema);

  if (errorMessage) {
    errs[input.name] = errorMessage;
  } else {
    delete errs[input.name];
  }

  const value = input.type === "checkbox" ? input.checked : input.value;
  const formData = { ...data };

  if (formData[input.name]) {
    formData[input.name].value = value;
  } else {
    formData[input.name] = {
      type: input.type,
      value: value,
    };
  }

  const returnObj = { Data: formData, Errors: errs };
  return returnObj;
}

export function compareForms(field, data, allFormSubmissions, formsyDetails) {
  if (data.SelectedProgram?.value && formsyDetails.SubmissionId !== "") {
    const latestSubmission = allFormSubmissions
      .filter((submission) => {
        const submissionCreatedOn = moment(submission.CreatedOn).startOf("day");
        const formsyCreatedOn = moment(formsyDetails.CreatedOn).startOf("day");

        return (
          submission.FinalSigned === "1" &&
          `{${submission.ClientProgramId}}` === data.SelectedProgram.value &&
          submissionCreatedOn.isSameOrBefore(formsyCreatedOn) &&
          submission.SubmissionId !== formsyDetails.SubmissionId
        );
      })
      .sort((a, b) => {
        const aDate = new Date(a.CreatedOn);
        const bDate = new Date(b.CreatedOn);

        if (aDate > bDate) return -1;
        if (aDate < bDate) return 1;
        return 0;
      })[0];

    console.log("LatestSubmission", latestSubmission);

    if (
      latestSubmission &&
      data[field] &&
      latestSubmission.FormResults.results[field]
    )
      return (
        data[field].value === latestSubmission.FormResults.results[field].value
      );
    else return false;
  }
}

/**
 * Get Formsy v2 Submissions for Object Id
 * @param {Array<guid>} containerId Array of Formsy v2 Form Container Ids
 * @param {guid} objectId Id used in Formsy v2 that matches the Primary, Secondary, or Tertiary Object Ids
 * @param {AbortSignal} signal AbortSignal from AbortController
 * @returns Object Array of Formsy v2 Submissions
 */
export async function getSubmissionsByContainerIdForObjectId(
  containerId,
  objectId
) {
  const body = {
    application: applicationId,
    command: "query",
    keyword: "submissionresultsbyobject",
    ids: ArrayCheck(containerId),
    searchTerms: { ObjectIdentifier: objectId },
  };
  const response = await zetoPost(`${apiUrl}/Container`, body);
  return response.data[0];
}

/**
 * Get Formsy v2 Submissions for Primary Object
 * @param {Array<guid>} containerId Array of Formsy v2 Form Container Ids
 * @param {guid} objectId Id used in Formsy v2 that matches the Primary, Secondary, or Tertiary Object Ids
 * @param {AbortSignal} signal AbortSignal from AbortController
 * @returns Object Array of Formsy v2 Submissions
 */
export async function getSubmissionsByContainerIdForPrimaryObjectId(
  containerId,
  objectId
) {
  const response = await getSubmissionsByContainerIdForObjectId(
    containerId,
    objectId
  );
  return response.Primary;
}

/**
 * Get Formsy v2 Submissions for Secondary Object
 * @param {Array<guid>} containerId Array of Formsy v2 Form Container Ids
 * @param {guid} objectId Id used in Formsy v2 that matches the Primary, Secondary, or Tertiary Object Ids
 * @param {AbortSignal} signal AbortSignal from AbortController
 * @returns Object Array of Formsy v2 Submissions
 */
export async function getSubmissionsByContainerIdForSecondaryObjectId(
  containerId,
  objectId
) {
  const response = await getSubmissionsByContainerIdForObjectId(
    containerId,
    objectId
  );
  return response.Secondary;
}

/**
 * Get Formsy v2 Submissions for Tertiary Object
 * @param {Array<guid>} containerId Array of Formsy v2 Form Container Ids
 * @param {guid} objectId Id used in Formsy v2 that matches the Primary, Secondary, or Tertiary Object Ids
 * @param {AbortSignal} signal AbortSignal from AbortController
 * @returns Object Array of Formsy v2 Submissions
 */
export async function getSubmissionsByContainerIdForTertiaryObjectId(
  containerId,
  objectId
) {
  const response = await getSubmissionsByContainerIdForObjectId(
    containerId,
    objectId
  );
  return response.Tertiary;
}

export const handleFieldTableChange = (data, e, index, fieldName) => {
  const input = e.currentTarget;

  const value =
    input.type === "checkbox" ? input.checked.toString() : input.value;

  const fieldValue = JSON.parse(data[fieldName].value);
  fieldValue[index][input.name] = value;

  if (!fieldValue[index]._id) {
    fieldValue[index]._id = cryptoRandomString(10);
  }

  return JSON.stringify(fieldValue);
};

export const handleAddFieldTableRow = (
  data,
  fieldName,
  newRow,
  unshift = false
) => {
  const fieldValue = JSON.parse(data[fieldName]?.value || "[]");

  if (unshift) {
    fieldValue.unshift({ ...newRow, _id: cryptoRandomString(10) });
  } else {
    fieldValue.push({ ...newRow, _id: cryptoRandomString(10) });
  }

  return JSON.stringify(fieldValue);
};

export const handleEditFieldTableRow = (data, index, fieldName) => {
  const fieldValue = JSON.parse(data[fieldName].value);
  fieldValue[index].IsEditable = true;

  if (!fieldValue[index]._id) {
    fieldValue[index]._id = cryptoRandomString(10);
  }

  return JSON.stringify(fieldValue);
};

export const handleSaveFieldTableRow = (data, index, fieldName) => {
  const fieldValue = JSON.parse(data[fieldName].value);
  fieldValue[index].IsEditable = false;

  if (!fieldValue[index]._id) {
    fieldValue[index]._id = cryptoRandomString(10);
  }

  return JSON.stringify(fieldValue);
};

export const handleDeleteFieldTableRow = (data, index, fieldName) => {
  const fieldValue = JSON.parse(data[fieldName].value);
  fieldValue.splice(index, 1);

  return JSON.stringify(fieldValue);
};

export const handleValidatedFieldTableChange = (
  data,
  e,
  index,
  fieldName,
  schema
) => {
  const input = e.currentTarget;
  const value =
    input.type === "checkbox" ? input.checked.toString() : input.value;

  const fieldValue = JSON.parse(data[fieldName].value);
  fieldValue[index][input.name] = value;

  if (!fieldValue[index]._id) {
    fieldValue[index]._id = cryptoRandomString(10);
  }

  const { error } = Joi.validate(
    { [fieldName]: fieldValue },
    { [fieldName]: schema[fieldName] },
    { abortEarly: false }
  );
  const errorMessage = error
    ? error.details.filter(
        (item) => item.path[1] === index && item.path[2] === input.name
      )[0]?.message
    : null;

  if (errorMessage) {
    fieldValue[index].Errors
      ? (fieldValue[index].Errors[input.name] = errorMessage)
      : (fieldValue[index].Errors = { [input.name]: errorMessage });
  } else {
    delete fieldValue[index].Errors?.[input.name];
  }

  return JSON.stringify(fieldValue);
};

export function sendShareEmail(
  recipientList,
  shareComments,
  pathname,
  formDescription
) {
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  const shareUrl = `${window.location.origin}/share${pathname}`;

  let body = `<p>${safyInfo.user.displayName} has shared a form. Click the link below to view it. Reply to this email to discuss it with ${safyInfo.user.displayName}.</p><p>${shareUrl}</p>`;
  if (shareComments !== "")
    body = `<p>${safyInfo.user.displayName} has shared a form with comments. Click the link below to view it. Reply to this email to discuss it with ${safyInfo.user.displayName}.</p><p>Comments:</p>${shareComments}<p>${shareUrl}</p>`;

  const toastId = toast.loading("Sending email...");

  sendEmail(
    recipientList,
    safyInfo.user.email,
    `${formDescription}: ${shareComments.slice(0, 500)}`,
    body
  )
    .then(() =>
      toast.update(toastId, {
        render: "Email sent successfully",
        type: "success",
        autoClose: 5000,
        isLoading: false,
        closeOnClick: true,
      })
    )
    .catch((error) =>
      toast.update(toastId, {
        render: `An error has occurred: ${
          JSON.parse(error).SystemResponse[0].Message
        }`,
        type: "error",
        autoClose: 5000,
        isLoading: false,
        closeOnClick: true,
      })
    );
}

export function handleCopyUrl(pathname) {
  return new Promise((resolve, reject) => {
    const shareUrl = `${window.location.origin}/share${pathname}`;

    navigator.clipboard
      .writeText(`${shareUrl}`)
      .then(() => {
        resolve();
      })
      .catch(() => {
        reject();
      });
  });
}
